module.exports = __webpack_public_path__ + "static/media/imge-7.650804f0.jpg";